import { combineEpics } from 'redux-observable';

import { fetchLead$ } from './fetchLead$';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics(fetchLead$);
